import React from "react";
import styles from "./AboutSection.module.css"; // CSS module import
import Line from '../../Assets/Vector.png'
import Image1 from '../../Assets/image1.png';
import Image2 from '../../Assets/image2.png'
import Image3 from '../../Assets/image3.png'
import Image4 from '../../Assets/image4.png'
import Image5 from '../../Assets/image5.png'
import Image6 from '../../Assets/image6.png'
import FeaturesSection from "../FeaturesSection/FeaturesSection";

const AboutSection = () => {
  return (
    <div className={styles.container}>
    <section id="about" className={styles.aboutSection}>
      <h2>About Our App</h2>
    {/* <div className={styles.divi}>
      </div>   */}
          <p>
       SS Media is a fast and reliable digital news platform designed for today’s generation.
We believe information should be simple, accurate, and accessible. Our mission is to make users staying informed and effortless by combining short news summaries and trending videos, refreshed throughout the day.
Whether you’re looking for breaking news, entertainment, politics, or viral clips, SS Media keeps you informed anytime, anywhere.
      </p>
      {/* <div className={styles.aboutImages}>
        <img src={Image1} alt="Community" />
        <img src={Image2} alt="Community" />
        <img src={Image3} alt="Community" />
        <img src={Image4} alt="Community" />
        <img src={Image5} alt="Community" />
       <img src={Image6} alt="Community" />
      </div> */}
    </section>
    {/* <div>
      <FeaturesSection />
    </div> */}
    </div>
  );
};

export default AboutSection;
